import React from 'react'
import {Form, Input, Select} from 'antd'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';

const { Option } = Select;
//运营商add表单页面
const OperatorForm=Form.create({
  name:'operator_form',
  // onFieldsChange(props, changedFields) {
  //   let obj={};
  //   Object.values(changedFields).forEach(item=>{
  //     obj[item.name]=item.value
  //   })
  //   props.onChange(obj);
  // },
  // mapPropsToFields(props){
  //   console.log(props)
  //   return {
  //     operator: Form.createFormField({value:props.operator.operator}),
  //     productNameListView: Form.createFormField({value:props.operator.productNameListView}),
  //     arrearsNotifyContent: Form.createFormField({value:props.operator.arrearsNotifyContent}),
  //     upcomingLockNotifyContent: Form.createFormField({value:props.operator.upcomingLockNotifyContent}),
  //     unbindNotifyContent: Form.createFormField({value:props.operator.unbindNotifyContent}),
  //     restartNotifyContent: Form.createFormField({value:props.operator.restartNotifyContent}),
  //     lockContent: Form.createFormField({value:props.operator.lockContent}),
  //   }
  // }
})(
  class OperatorFormClass extends React.Component{
    render(){     
      const { t,form,productList }=this.props
      const {operator,productNameListView,arrearsNotifyContent,upcomingLockNotifyContent,unbindNotifyContent,restartNotifyContent,lockContent,arrearsNotifyTitle,upcomingLockNotifyTitle,unbindNotifyTitle,restartNotifyTitle,lockTitle}=this.props.operator
      const { getFieldDecorator } = form
      // const formItemLayout = {
      //   labelCol: {
      //     xs: { span: 4 },
      //     sm: { span: 4 },
      //   },
      //   wrapperCol: {
      //     xs: { span: 20 },
      //     sm: { span: 20 },
      //   },
      // }
      return (
        <Form layout="vertical">          
          <Form.Item label={t('Carrier Code')}>
            {getFieldDecorator('operator',{
              rules:[{required:true,message:t("-Enter-")}],
              initialValue:operator
            })(
              <Input></Input>
            )}
          </Form.Item>
          <Form.Item label={t('Product List')}>
            {getFieldDecorator('productNameListView',{
              rules:[{required:true,message:t("-Enter-")}],
              initialValue:productNameListView
            })(
              <Select mode="multiple">
                {
                  productList.map((product)=><Option value={product} key={product}>{product}</Option>)
                }
              </Select>
            )}
          </Form.Item>
          <Form.Item label={t('Payment Notification')}>
          {getFieldDecorator('arrearsNotifyTitle',{
              initialValue:arrearsNotifyTitle
            })(
              <Input placeholder="title" style={{marginBottom:'10px'}}></Input>
            )}
            {getFieldDecorator('arrearsNotifyContent',{
              initialValue:arrearsNotifyContent
            })(
              <Input placeholder="content"></Input>
            )}
          </Form.Item>
          <Form.Item label={t('Notification Before Locking Phone')}>
          {getFieldDecorator('upcomingLockNotifyTitle',{
              initialValue:upcomingLockNotifyTitle
            })(
              <Input placeholder="title" style={{marginBottom:'10px'}}></Input>
            )}
            {getFieldDecorator('upcomingLockNotifyContent',{
              initialValue:upcomingLockNotifyContent
            })(
              <Input  placeholder="content"></Input>
            )}
          </Form.Item>
          <Form.Item label={t('Unbind Contract')}>
          {getFieldDecorator('unbindNotifyTitle',{
              initialValue:unbindNotifyTitle
            })(
              <Input placeholder="title" style={{marginBottom:'10px'}}></Input>
            )}
            {getFieldDecorator('unbindNotifyContent',{
              initialValue:unbindNotifyContent
            })(
              <Input placeholder="content"></Input>
            )}
          </Form.Item>

          <Form.Item label={t('Restart Pop-Up Window')}>
          {getFieldDecorator('restartNotifyTitle',{
              initialValue:restartNotifyTitle
            })(
              <Input placeholder="title" style={{marginBottom:'10px'}}></Input>
            )}
            {getFieldDecorator('restartNotifyContent',{
              initialValue:restartNotifyContent
            })(
              <Input placeholder="content"></Input>
            )}
          </Form.Item>
          <Form.Item label={t('On Lock Screen Message')}>
          {getFieldDecorator('lockTitle',{
              initialValue:lockTitle
            })(
              <Input placeholder="title" style={{marginBottom:'10px'}}></Input>
            )}
            {getFieldDecorator('lockContent',{
              initialValue:lockContent
            })(
              <Input placeholder="content"></Input>
            )}
          </Form.Item>
        </Form>
      )
    }
  }
)

const mapStateToProps = (state)=>{
  return {
    roles:state.roles
  }
}

export default connect(mapStateToProps)(withTranslation()(OperatorForm))